import * as actionTypes from '../constants/idex';

import axios from '../../../../shared/axios/axios';

const getPdfFileStart = () => {
  return {
    type: actionTypes.COVER_PAGE_GET_PDF_FILE_START,
  };
};

const getPdfFileSuccess = (data) => {
  return {
    type: actionTypes.COVER_PAGE_GET_PDF_FILE_SUCCESS,
    data,
  };
};

const getPdfFileFail = (error) => {
  return {
    type: actionTypes.COVER_PAGE_GET_PDF_FILE_FAIL,
    error,
  };
};

export const getCoverPage = () => {
  return (dispatch) => {
    dispatch(getPdfFileStart());
    const url = `/coverpage/get-cover-page`;

    axios
      .get(url)
      .then((response) => {
        dispatch(getPdfFileSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPdfFileFail(err));
      });
  };
};
